import { getToken } from "../../helper/common";
import agent from "../services/agent";
import {
  SET_APPROVALS_LIST,
  SET_INITIAL_STATE,
  OPEN_APPROVAL_ACTION_MODAL,
  CLOSE_APPROVAL_ACTION_MODAL,
  SET_APPROVALS_PENDING,
  SUBMIT_APPROVAL_ACTION_PENDING,
  SUBMIT_APPROVAL_ACTION_SUCCESS,
  SUBMIT_APPROVAL_ACTION_ERROR,
  CLEAR_SUBMIT_APPROVAL_ACTION_ERROR,
  SET_APPROVALS_FORM,
  APPROVAL_LIST_ERROR,
  SET_PAGE_SIZE_GLOBAL,
  SET_APPROVALS_LIST_COUNT,
  APPROVAL_LIST_COUNT_ERROR,
  SET_ACTION,
  SET_SELECTED_REQUEST_ID,
} from "../approvals/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";

export const setPageSizeGlobal = (pageSize) => ({
  type: SET_PAGE_SIZE_GLOBAL,
  payload: { pageSize },
});

//-------------------------------APPROVAL-LIST------------------------------------------
export const approvalListError = (errorMessage) => ({
  type: APPROVAL_LIST_ERROR,
  payload: { errorMessage },
});

export const approvalListCountError = (errorMessage) => ({
  type: APPROVAL_LIST_COUNT_ERROR,
  payload: { errorMessage },
});

export const setApprovalsPending = () => ({
  type: SET_APPROVALS_PENDING,
});

const setApprovalsList = (approvalsOdata) => ({
  type: SET_APPROVALS_LIST,
  payload: { approvalsOdata },
});
const setApprovalsListCount = (approvalsOdata) => ({
  type: SET_APPROVALS_LIST_COUNT,
  payload: { approvalsOdata },
});

export const setApprovalsForm = (approvalsForm) => ({
  type: SET_APPROVALS_FORM,
  payload: { approvalsForm },
});

export const getApprovalsList = (page, pageSize, searchStatus, sortDirection, sortOrder) => (dispatch) => {
  dispatch(setApprovalsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Approval.getApprovals(accessToken, page, pageSize, searchStatus, sortDirection, sortOrder)
      .then((approvalList) => {
        dispatch(setApprovalsList(approvalList));
      })
      .catch((err) => {
        console.log("getApprovals server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(approvalListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(approvalListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getApprovalsListCount = () => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Approval.getApprovalsCount(accessToken)
      .then((approvalList) => {
        dispatch(setApprovalsListCount(approvalList));
      })
      .catch((err) => {
        console.log("getApprovals server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(approvalListCountError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(approvalListCountError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//-------------------------------APPROVAL-ACTIONS---------------------------------------
export const setAction = (actionType) => ({
  type: SET_ACTION,
  payload: { actionType },
});
export const setSelectedRequestId = (selectedId) => ({
  type: SET_SELECTED_REQUEST_ID,
  payload: { selectedId },
});
export const submitApprovalActionPending = () => ({
  type: SUBMIT_APPROVAL_ACTION_PENDING,
});

export const submitApprovalActionSuccess = () => ({
  type: SUBMIT_APPROVAL_ACTION_SUCCESS,
});

export const submitApprovalActionError = (errorMessage) => ({
  type: SUBMIT_APPROVAL_ACTION_ERROR,
  payload: { errorMessage },
});

export const clearSubmitApprovalActionError = () => ({
  type: CLEAR_SUBMIT_APPROVAL_ACTION_ERROR,
});

export const setRequestActionFormInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const openApprovalActionModal = () => ({
  type: OPEN_APPROVAL_ACTION_MODAL,
});

export const closeApprovalActionModal = () => ({
  type: CLOSE_APPROVAL_ACTION_MODAL,
});

export const submitApprovalAction = (action, requestId) => (dispatch, getState) => {
  const currentState = getState();
  const { approvalsForm, pageSizeGlobal } = currentState && currentState.approvals;
  if (!approvalsForm) {
    dispatch(submitApprovalActionError("Please fill required details."));
    return;
  }

  const submitRequest = {
    comments: approvalsForm.comments,
    approveAction: action,
    requestId,
  };

  dispatch(submitApprovalActionPending());
  dispatch(clearSubmitApprovalActionError());
  getToken(dispatch).then((accessToken) => {
    agent.Approval.submitApproval(accessToken, submitRequest)
      .then(() => {
        dispatch(submitApprovalActionSuccess());
        // dispatch(clearForm());
        dispatch(getApprovalsListCount());
        dispatch(closeApprovalActionModal());
        dispatch(getApprovalsList(1, pageSizeGlobal, 'pending'));
        dispatch(showSnackbarStatus("User action submitted successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(submitApprovalActionError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(submitApprovalActionError(message));
        }
        console.log("submitApprovalAction server error", err);
        // dispatch(clearForm());
        // dispatch(submitApprovalActionError(null));
        // dispatch(closeApprovalActionModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};